<template>
  <footer class="presentation-page-footer">
    <div class="presentation-page-footer__line" aria-hidden="true"></div>
    <div class="presentation-page-footer__row">
      <p class="presentation-page-footer__brand">
        e way Energy GmbH · One Life · One Planet · One Way
      </p>
      <p class="presentation-page-footer__page-number">{{ pageNumber }} / {{ pageCount }}</p>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'PresentationPageFooter',

  props: {
    pageNumber: {
      type: Number,
      required: true,
    },
    pageCount: {
      type: Number,
      required: true,
    },
  },
};
</script>
